import { render, staticRenderFns } from "./my_order.vue?vue&type=template&id=64fa5280&"
import script from "./my_order.vue?vue&type=script&lang=js&"
export * from "./my_order.vue?vue&type=script&lang=js&"
import style0 from "./my_order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports